//adding comment
import React, { useState } from "react";
import "./App.css";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import UserLogin from "./pages/UserLogin";
import UserSignUp from "./pages/UserSignUp";
import ExpertSignup from "./pages/ExpertSignUp";
import ExpertLogin from "./pages/ExpertLogin";
import FresherJob from "./pages/FresherJob";
import Internship from "./pages/Internship";
import Cluster from "./pages/Cluster";
import NewCluster from "./pages/NewCluster";
import UserHomePage from "./pages/User/Home/UserHomePage";
import Mentor from "./pages/Mentor";
import About from "./pages/About";
import User from "./pages/User";
import Pricing from "./pages/Pricing";
import ComingSoon from "./pages/ComingSoon";
import Profile from "./pages/Profile";
import ProfileCluster from "./pages/ProfileCluster";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UserProfile from "./pages/UserProfile";
import UserSession from "./pages/User/UserSession/UserSession";
import UserTopics from "./pages/UserTopics";
import ExpertBenefits from "./pages/ExpertBenefits";
import AlluserProfile from "./pages/AlluserProfile";
import Next2LoginPage from "./DomainExpertPages/Next2LoginPage";
import Chatpage from "./ChatApp/Pages/Chatpage";
// import ChatNext from "./ChatApp/components/ChatNext";
import ClusterHome from "./components/ClusterContent/ClusterHome";
import SingleChat from "./ChatApp/components/SingleChat";
// import CreateClusterPage from "./pages/CreateClusterPage";
import { ChatState } from "./ChatApp/Context/ChatProvider";
import ThankYou from "./pages/ThankYou";
import ZeoCloud from "./pages/ZegoCloud";
import TermsConditions from "./pages/TermsConditions";
import ContactUs from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import BookSession from "./pages/User/BookSession";
import CalendlyWidget from "./components/CalendlyWidget";
import ExpertDashboard from "./pages/Expert/Dashboard/ExpertDashboard";
import ProtectedRoutes from "./services/protectedRoutes";
import MagicAI from "./pages/MagicAI";
import NotificationPage from "./pages/Notification";
import Feedback from "./FeedBack/Feedback";

function App() {
  const [showPassword, setShowPassword] = useState(false);
  const [hideFooter, setHideFooter] = useState(false);
  const [hideNavbar, setHideNavbar] = useState(false);

  //aman's code
  const [expertToken, setExpertToken] = useState(
    localStorage.getItem("EXPERT_AUTH_TOKEN") || null
  );
  const [expertDetails, setExpertDetails] = useState(
    JSON.parse(localStorage.getItem("EXPERT_INFO")) || null
  );
console.log(expertDetails);
  const [userToken, setUserToken] = useState(
    localStorage.getItem("USER_AUTH_TOKEN") || null
  );
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("USER_INFO")) || null
  );
console.log(userDetails)
  const handleExpertLogin = (newToken, newExpertDetails) => {
    setExpertToken(newToken);
    setExpertDetails(newExpertDetails);
  };

  const handleUserLogin = (newToken, newUserDetails) => {
    setUserToken(newToken);
    setUserDetails(newUserDetails);
  };

  const handleLogout = () => {
    localStorage.removeItem("EXPERT_AUTH_TOKEN");
    localStorage.removeItem("EXPERT_INFO");
    localStorage.removeItem("USER_AUTH_TOKEN");
    localStorage.removeItem("USER_INFO");
    window.open(`${process.env.REACT_APP_BASE_URL}/auth/logout`, "_self");
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const hideFooterPaths = [
    "/usersignup",
    "/usersession",
    "/userlogin",
    "/problemsolver/signup",
    "/problemsolver/login",
    "/problemsolver/signup",
    "/problemsolver/dashboard",
    "/userprofile",
  ];
  const hideNavbarPaths = ["/problemsolver/dashboard"];

  // Function to update footer visibility based on current route
  const updateFooterVisibility = () => {
    const shouldHide = hideFooterPaths.includes(window.location.pathname);
    setHideFooter(shouldHide);
  };
  const updateNavbarVisibility = () => {
    const shouldHideNav = hideNavbarPaths.includes(window.location.pathname);
    setHideNavbar(shouldHideNav);
  };

  // Use the 'useLocation' hook to listen for route changes
  const location = useLocation();
  React.useEffect(() => {
    updateFooterVisibility(); // Update footer visibility when route changes
    updateNavbarVisibility();
  }, [location]);

  return (
    <>
      {/* Conditionally render the navbar */}
      {!hideNavbar && (
        <Navbar
          handleLogout={handleLogout}
          token={userToken}
          userDetails={userDetails}
        />
      )}

      <ToastContainer
        theme="colored"
        autoClose={3000}
        position={"top-right"}
      />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/userlogin"
          element={<UserLogin onLogin={handleUserLogin} />}
        />
        <Route
          path="/usersignup"
          element={
            <UserSignUp
              showPassword={showPassword}
              setShowPassword={setShowPassword}
              toggleShowPassword={toggleShowPassword}
            />
          }
        />
        <Route path="/problemsolver/signup" element={<ExpertSignup />} />
        <Route
          path="/problemsolver/login"
          element={<ExpertLogin onLogin={handleExpertLogin} />}
        />

        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="/magicAI" element={<MagicAI />} />
        <Route path="/profile/:id" element={<Profile />} />
        <Route path="/fresherjob" element={<ComingSoon />} />
        <Route path="/internship" element={<ComingSoon />} />
        <Route path="/cluster" element={<Cluster />} />
        <Route path="/newcluster" element={<NewCluster />} />
        <Route path="/profilecluster" element={<ProfileCluster />} />
        <Route path="/home" element={<UserHomePage />} />
        <Route path="/user-topic" element={<UserTopics />} />
        <Route path="/expert-benefits" element={<ExpertBenefits />} />

        <Route path="/booksession/:sessionId" element={<BookSession />} />
        <Route
          path="/problemsolver/dashboard"
          element={<ProtectedRoutes tokenType="expert" />}
        >
          <Route
            path="/problemsolver/dashboard"
            element={
              <ExpertDashboard
                handleLogout={handleLogout}
                expertDetails={expertDetails}
              />
            }
          />
        </Route>
        <Route path="/CalendlyWidget" element={<CalendlyWidget />} />
        <Route path="/Next2LoginPageexpert" element={<Next2LoginPage />} />
        <Route path="/user" element={<User />} />
        <Route path="/problemsolverpage" element={<Mentor />} />
        <Route path="/about" element={<About />} />
        <Route path="/comingsoon" element={<ComingSoon />} />
        <Route
          path="/userprofile"
          element={
            <UserProfile
              token={userToken || expertToken}
              userDetails={userDetails || expertDetails}
            />
          }
        />

        <Route path="/usersession" element={<UserSession />} />
        <Route path="/AlluserProfile/:userId" element={<AlluserProfile />} />
        <Route path="/userprofile/editt/:id" element={<UserProfile />} />
        <Route path="/chatpage" element={<Chatpage />} />
        {/* <Route path="/zegocloud" element={<ZeoCloud />} /> */}
        <Route path="/chat_box_page" element={<SingleChat />} />
        <Route path="/yourcluster" element={<ClusterHome />} />
        <Route
          path="/create-cluster-redirection/:clusterName"
          element={<ClusterHome />}
        />
        <Route path="/term&conditions" element={<TermsConditions />} />
        <Route path="/privacy&policy" element={<PrivacyPolicy />} />
        <Route path="/contactUs" element={<ContactUs />} />
        <Route path="/career" element={<ComingSoon />} />
        <Route path="/blog" element={<ComingSoon />} />
        <Route path="/topics" element={<ComingSoon />} />
        <Route path="/feedback" element={<ComingSoon />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/notifications" element={<NotificationPage />} />
      </Routes>
      {/* Conditionally render the footer */}
      {!hideFooter && <Footer />}
    </>
  );
}

export default App;
